import React from 'react';

import {
    Home,
    Login,
    Logout,
    Settings,
    Restaurant,
    Restaurants,
    Organisation,
    Organisations,
    Menu,
    Overview,
    Report,
    UserDetails,
    FoodServiceCategories,
    FeedbackQuestions,
    FeedbackReporting
} from './containers';

export default [
    {
        exact: true,
        path: '/login',
        fillScope: true,
        component: (scope) => (props) => <Login {...props} {...scope} />
    },

    {
        exact: true,
        path: '/settings',
        component: Settings
    },

    {
        exact: true,
        path: '/food-service-categories',
        component: FoodServiceCategories
    },

    {
        exact: true,
        path: '/feedback-reports',
        component: FeedbackReporting
    },

    {
        exact: true,
        path: '/feedback-questions',
        component: FeedbackQuestions
    },

    {
        exact: true,
        path: '/overview',
        component: Overview
    },

    {
        exact: true,
        path: '/user',
        component: UserDetails
    },

    {
        exact: true,
        path: '/logout',
        component: Logout
    },

    {
        auth: true,
        exact: true,
        path: '/',
        component: Home
    },

    {
        auth: true,
        exact: true,
        path: '/organisations',
        component: Organisations
    },

    {
        auth: true,
        exact: true,
        path: '/organisations/:organisationId',
        component: Organisation
    },

    {
        auth: true,
        exact: true,
        path: '/restaurants',
        component: Restaurants
    },

    {
        auth: true,
        exact: true,
        path: '/restaurants/:restaurantId',
        component: Restaurant
    },

    {
        auth: true,
        exact: true,
        path: '/restaurants/:restaurantId/menus/:menuId',
        component: Menu
    },

    {
        auth: true,
        exact: true,
        path: '/restaurants/:restaurantId/reports/:reportId',
        component: Report
    },
];



// WEBPACK FOOTER //
// ./resources/assets/js/Routes.js